var HIDDEN_PROPERTY_GRID_CATEGORIES = [
    "layout",
    "choicesByUrl",
    "questionSettings",
    "numbering",
    "timer",
];
var SEPARATE_SPECIAL_CHOICES_TYPES = [
    "checkbox",
    "tagbox",
    "ranking",
    "radiogroup",
    "imagepicker",
    "buttongroup",
    "dropdown",
];
var VALUE_PROPERTY_NAME_TYPES = [
    "checkbox",
    "tagbox",
    "ranking",
    "imagemap",
];
var COPY_FROM_LAST_ENTRY_TYPES = ["matrixdynamic", "paneldynamic"];
var QUESTION_COMMON_PROPERTIES = [
    "useDisplayValuesInDynamicTexts",
    "clearIfInvisible",
    "bindings",
];
var HIDDEN_MATRIX_DROPDOWN_BASE_PROPERTIES = ["detailPanelMode"];
var HIDDEN_MATRIX_COLUMN_PROPERTIES = [
    "width",
    "minWidth",
    "totalExpression",
    "totalFormat",
];
var HIDDEN_DATA_TAB_MATRIX_DYNAMIC_PROPERTIES = [
    "defaultRowValue",
    "defaultValueFromLastRow",
];
var HIDDEN_SURVEY_GENERAL_PROPERTIES = [
    "locale",
    "mode",
    "cookieName",
    "widthMode",
    "firstPageIsStarted",
    "questionTitleLocation",
    "questionDescriptionLocation",
    "questionTitlePattern",
    "questionStartIndex",
    "questionErrorLocation",
    "allowResizeComment",
    "gridLayoutEnabled",
    "sendResultOnPageNext",
    "storeOthersAsComment",
    "focusOnFirstError",
    "showCompletedPage",
    "completedHtml",
    "completedHtmlOnCondition",
    "loadingHtml",
    "completedBeforeHtml",
];
var HIDDEN_SERIALIZER_PROPERTIES = {
    text: ["dataList"],
    radiogroup: ["choicesFromQuestion", "choicesFromQuestionMode"],
    rating: ["displayMode", "scaleColorMode", "rateColorMode"],
    dropdown: [
        "searchMode",
        "searchEnabled",
        "choicesFromQuestion",
        "choicesFromQuestionMode",
    ],
    tagbox: [
        "searchMode",
        "searchEnabled",
        "choicesFromQuestion",
        "choicesFromQuestionMode",
    ],
    file: [
        "sourceType",
        "photoPlaceholder",
        "fileOrPhotoPlaceholder",
        "storeDataAsText",
        "imageHeight",
        "imageWidth",
    ],
    imagepicker: [
        "imageHeight",
        "imageWidth",
        "choicesFromQuestion",
        "choicesFromQuestionMode",
    ],
    checkbox: ["choicesFromQuestion", "choicesFromQuestionMode"],
    buttongroup: ["choicesFromQuestion", "choicesFromQuestionMode"],
    ranking: [
        "choicesFromQuestion",
        "choicesFromQuestionMode",
        "selectToRankEnabled",
    ],
    matrixdropdown: ["totalText"],
    matrixdynamic: ["keyName"],
    signaturepad: [
        "waitForUpload",
        "storeDataAsText",
        "signatureAutoScaleEnabled",
    ],
    page: ["timeLimit"],
};
var hideSerializerProperty = function (serializer, className, propertyName) {
    var property = serializer.getProperty(className, propertyName);
    if (property) {
        property.visible = false;
    }
};
var forceHidePropertyVisibleIf = function (serializer, className, propertyName) {
    var property = serializer.getProperty(className, propertyName);
    if (property) {
        property.visibleIf = function () { return false; };
    }
};
var hidePropertyGridCategory = function (survey, categoryName) {
    var page = survey.getPageByName(categoryName);
    if (page) {
        page.delete();
        return;
    }
    var panel = survey.getPanelByName(categoryName);
    panel === null || panel === void 0 ? void 0 : panel.delete();
};
export var configureGlobalPropertyGrid = function (serializer) {
    HIDDEN_SURVEY_GENERAL_PROPERTIES.forEach(function (propertyName) {
        hideSerializerProperty(serializer, "survey", propertyName);
    });
    SEPARATE_SPECIAL_CHOICES_TYPES.forEach(function (className) {
        hideSerializerProperty(serializer, className, "separateSpecialChoices");
    });
    VALUE_PROPERTY_NAME_TYPES.forEach(function (className) {
        hideSerializerProperty(serializer, className, "valuePropertyName");
    });
    COPY_FROM_LAST_ENTRY_TYPES.forEach(function (className) {
        hideSerializerProperty(serializer, className, "copyDefaultValueFromLastEntry");
    });
    QUESTION_COMMON_PROPERTIES.forEach(function (propertyName) {
        hideSerializerProperty(serializer, "question", propertyName);
    });
    HIDDEN_MATRIX_DROPDOWN_BASE_PROPERTIES.forEach(function (propertyName) {
        hideSerializerProperty(serializer, "matrixdropdownbase", propertyName);
    });
    HIDDEN_MATRIX_COLUMN_PROPERTIES.forEach(function (propertyName) {
        hideSerializerProperty(serializer, "matrixdropdowncolumn", propertyName);
    });
    HIDDEN_DATA_TAB_MATRIX_DYNAMIC_PROPERTIES.forEach(function (propertyName) {
        hideSerializerProperty(serializer, "matrixdynamic", propertyName);
    });
    Object.entries(HIDDEN_SERIALIZER_PROPERTIES).forEach(function (_a) {
        var className = _a[0], propertyNames = _a[1];
        propertyNames.forEach(function (propertyName) {
            hideSerializerProperty(serializer, className, propertyName);
        });
    });
    forceHidePropertyVisibleIf(serializer, "page", "navigationButtonsVisibility");
};
export var configureGlobalCreatorPropertyGrid = function (creator) {
    creator.onSurveyInstanceCreated.add(function (_, options) {
        if (options.area !== "property-grid") {
            return;
        }
        HIDDEN_PROPERTY_GRID_CATEGORIES.forEach(function (categoryName) {
            hidePropertyGridCategory(options.survey, categoryName);
        });
    });
};
